import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { getRoundFromIdAtom } from "../../../../../../../../../../../atoms/selectors/getRoundFromIdAtom/getRoundFromIdAtom";

export const getTransportationTypeFromRoundIdAtom = atomFamily(
  (roundId: string) => {
    return atom((get) => {
      const round = get(getRoundFromIdAtom(roundId));
      return round?.type === "Golf" ? round?.transportationType?.id : null;
    });
  }
);
